import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getMatchQuestions } from '../api/match-api';
import { matchKeys } from '../queryKeys';
import { normalizeMatchLocale } from '../../../i18n/matchLocale';

/** Bundled quiz copy changes rarely; reuse while species unchanged. */
const STALE_MS = 5 * 60 * 1000;
const GC_MS = 30 * 60 * 1000;

export type UseMatchQuestionsQueryOptions = {
  /** When false, skips fetch (e.g. species gate before quiz phase). */
  enabled?: boolean;
};

export function useMatchQuestionsQuery(
  species: 'Cat' | 'Dog',
  options?: UseMatchQuestionsQueryOptions,
) {
  const { i18n } = useTranslation('matching');
  const enabled = options?.enabled ?? true;
  const locale = normalizeMatchLocale(i18n.resolvedLanguage ?? i18n.language);

  return useQuery({
    queryKey: matchKeys.questions(species, locale),
    queryFn: () => getMatchQuestions(species, locale),
    staleTime: STALE_MS,
    gcTime: GC_MS,
    enabled,
  });
}
